import {customElement} from "lit/decorators.js";
import {Resolution} from "../../../common/resolution";
import {resolve} from "../../../container";
import {ScrollService} from "../../../common/scroll";
import {EopExecutiveBoardGallery, executiveBoardGalleryConfig} from "./executiveBoardGallery";

@customElement("eop-executive-board-gallery-6-no-intro-image")
export class EopExecutiveBoardGallerySixWithoutGroupShot extends EopExecutiveBoardGallery {

    public constructor(resolution: Resolution = resolve(Resolution), scrollService: ScrollService = resolve(ScrollService)) {
        // has duplicate in scss
        const portraitOnStageTimeline = [0, 0.19, 0.38, 0.57, 0.76, 0.95];
        const config = executiveBoardGalleryConfig(portraitOnStageTimeline, {portraitCount: 6, hasGroupShot: false});
        super(config, resolution, scrollService);
    }
}
